'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
export default class PDFPageImage extends PureComponent {
  constructor(...args) {
    super(...args);

    this.renderPageImage = () => {
      const {
        pageObject,
        viewport
      } = this.props;
      const {
        height,
        width,
        retinaScale
      } = viewport; // Need to add a new canvas element on each render to prevent flicker
      // See https://github.com/mikecousins/react-pdf-js/pull/51 for more context

      const canvas = document.createElement('canvas');
      const parentElement = this.canvasParent;
      const previousCanvas = parentElement.firstChild;

      if (previousCanvas) {
        parentElement.replaceChild(canvas, previousCanvas);
      } else {
        parentElement.appendChild(canvas);
      }

      const canvasContext = this.canvasParent.firstChild.getContext('2d');
      this.canvasParent.firstChild.height = height;
      this.canvasParent.firstChild.width = width;
      this.canvasParent.firstChild.style.height = `${height / retinaScale}px`;
      this.canvasParent.firstChild.style.width = `${width / retinaScale}px`;
      pageObject.render({
        canvasContext,
        viewport
      });
    };
  }

  componentDidMount() {
    this.renderPageImage();
  }

  componentDidUpdate() {
    this.renderPageImage();
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      style: {
        margin: 'auto'
      },
      ref: c => {
        this.canvasParent = c;
      }
    });
  }

}
PDFPageImage.propTypes = {
  pageObject: PropTypes.object.isRequired,
  viewport: PropTypes.object.isRequired
};